var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"disabled":_vm.items.length === 0},on:{"click":_vm.downloadCSV}},[_vm._v("CSVダウンロード")])
}
var staticRenderFns = []

export { render, staticRenderFns }